<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <input-checkbox
        class="checkbox caption"
        v-bind:title="name"
        v-on:click.native.stop
        v-model="selectGroup" />
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <input-checkbox
        class="checkbox"
        v-bind:key="id"
        v-bind:title="title"
        v-bind:value="value"
        v-for="{ id, title, value } in permissionsInputs"
        v-on:input="onSelectPermission(id, $event)" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import InputCheckbox from '@/components/InputCheckbox.vue';

/**
 * @description Группа прав.
 * @type {any}
 */
export default {
  components: { InputCheckbox },
  computed: {
    /**
     * @description Вводы разрешений.
     * @returns {{id: string, title: string, value: boolean}[]}
     */
    permissionsInputs() {
      return this.permissions.map(({ slug, name }) => {
        const value = this.selected.includes(slug);
        return { id: slug, title: name, value };
      });
    },
    /**
     * @description Идентификаторы разрешений.
     * @returns {string[]}
     */
    permissionIds() {
      return this.permissions.map(({ slug }) => slug);
    },
    selectGroup: {
      get() {
        return this.selectedCountByGroup !== 0;
      },
      set(isChecked) {
        const other = this.selected.flatMap(
          (item) => (this.permissionIds.includes(item) ? [] : [item]),
        );
        const value = isChecked ? other.concat(this.permissionIds) : other;
        this.onInput(value);
      },
    },
    selectedCountByGroup() {
      return this.selected.filter((item) => this.permissionIds.includes(item)).length;
    },
  },
  data() {
    return {
      selected: this.value || [],
    };
  },
  methods: {
    onSelectPermission(permissionId, isChecked) {
      const value = isChecked
        ? this.selected.concat([permissionId])
        : this.selected.filter((item) => item !== permissionId);
      this.onInput(value);
    },
    onInput(value) {
      this.selected = value;
      this.$emit('input', value);
    },
  },
  props: {
    /**
     * @description Название.
     */
    name: {
      required: true,
      type: String,
    },
    /**
     * @description Разрешения.
     */
    permissions: {
      required: true,
      type: Array,
    },
    /**
     * @description Идентификаторы выбранных разрешений.
     * @type {string[]}
     */
    value: {
      required: true,
      type: Array,
    },
  },
  watch: {
    value(updatedValue) {
      this.selected = updatedValue;
    },
  },
};
</script>
<style lang="scss">
.checkbox {
  display: block;
  max-width: fit-content;
  &.caption {
    .checkbox__title {
      font-weight: 600;
    }
  }
}
</style>
